import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RoutesRecognized, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import { SigninService, UserService, ContextService } from '../../shared';
import { User, Etablissement, Pays, Civilite } from '../../shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  providers: [ SigninService ]
})
export class SignInComponent implements OnInit {

  context:string;
  previousUrl: string;
  isFinish:boolean=false;
  hasError:boolean=false;
  signinForm:FormGroup;
  msgAlert:string;
  profils_pro:Array<any>; //= [
  //   {id:202, libelle:'Enseignant acheteur'},
  //   {id:203, libelle:'Agent comptable'},
  //   {id:204, libelle:'Acheteur collectivité'}
  // ];

  civilites: Array<Civilite>;

  conf_email:string;
  conf_pw:string;
  user: User = new User();
  token:string = '';
  temp_uai:string;
  disable_uai: boolean = false;
  uai_error: boolean = false;
  etablissements:Array<Etablissement> = [];
  pays:Array<Pays> = [];

  response:any;

  constructor(
    private contextService: ContextService,
  	private signinService: SigninService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {

    this.context = this.contextService.getContext();
    this.user.idPaysLPC = 33
    if(this.context == 'B2B'){
      this.signinForm = formBuilder.group({
        signIn_profil: [null, Validators.compose([Validators.required])],
        signIn_civ: ['', Validators.compose([Validators.required])],
        signIn_nom: ['', Validators.compose([Validators.required])],
        signIn_prenom: ['', Validators.compose([Validators.required])],
        matchingEmail: formBuilder.group({
          signIn_email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]+$')])],
          signIn_email2: ['', Validators.compose([Validators.required])]
        }, { validator: matchingEmails('signIn_email', 'signIn_email2') }),
        signIn_identifiant: ['', Validators.compose([Validators.required])],
        matchingPassword: formBuilder.group({
          signIn_mdp: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('^[a-zA-z0-9]+$')])],
          signIn_mdp2: ['', Validators.compose([Validators.required])]
        }, { validator: matchingPasswords('signIn_mdp', 'signIn_mdp2') }),
        signIn_adr: ['', Validators.compose([Validators.required])],
        signIn_adr2: [''],
        signIn_zip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
        signIn_telephone: ['', Validators.compose([Validators.minLength(8)])],
        signIn_ville: ['', Validators.compose([Validators.required])],
        signIn_pays: [null, Validators.compose([Validators.required])],
        signIn_code_uai: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(8)])],
        // signIn_captcha: ['', Validators.compose([Validators.required])]
      });
    } else {
      this.signinForm = formBuilder.group({
        signIn_profil: [null],
        signIn_civ: ['', Validators.compose([Validators.required])],
        signIn_nom: ['', Validators.compose([Validators.required])],
        signIn_prenom: ['', Validators.compose([Validators.required])],
        matchingEmail: formBuilder.group({
          signIn_email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]+$')])],
          signIn_email2: ['', Validators.compose([Validators.required])]
        }, { validator: matchingEmails('signIn_email', 'signIn_email2') }),
        signIn_identifiant: ['', Validators.compose([Validators.required])],
        matchingPassword: formBuilder.group({
          signIn_mdp: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[A-Z])([a-zA-z0-9])+$')])],
          signIn_mdp2: ['', Validators.compose([Validators.required])]
        }, { validator: matchingPasswords('signIn_mdp', 'signIn_mdp2') }),
        signIn_adr: ['', Validators.compose([Validators.required])],
        signIn_adr2: [''],
        signIn_zip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
        signIn_telephone: ['', Validators.compose([Validators.minLength(8)])],
        signIn_ville: ['', Validators.compose([Validators.required])],
        signIn_pays: [null, Validators.compose([Validators.required])],
        signIn_code_uai: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(8)])],
        // signIn_captcha: ['', Validators.compose([Validators.required])]
      });
    }

    function matchingPasswords(pw:string, pw2:string){
      return (group: FormGroup): {[key: string]: any} => {
        let password = group.controls[pw];
        let confirmPassword = group.controls[pw2];

        if (password.value !== confirmPassword.value) {
          return {
            mismatchedPasswords: true
          };
        }
      }
    }

    function matchingEmails(email:string, email2:string){
      return (group: FormGroup): {[key:string]:any} => {
        let t_email = group.controls[email];
        let confirmEmail = group.controls[email2];

        if(t_email.value !== confirmEmail.value) {
          return {
            mismatchedEmails: true
          };
        }
      }
    }

  }

  ngOnInit() {

    console.log(this.signinForm['controls'].signIn_profil)

  	this.signinService.getAllCivilites()
  		.subscribe(civilites => {
        console.log(civilites);
  			this.civilites = civilites;
  		});

    if(this.context == 'B2B'){
      this.signinService.getAllPays()
        .subscribe(pays => {
          this.pays = pays;

        });

      this.signinService.getAllTypes()
        .subscribe(types => {
          this.profils_pro = types;
        });
    } else {
      this.signinService.getFrancePays()
        .subscribe(pays => {
          this.pays = pays;
          

        });
    }

    this.router.events
      .filter(e => e instanceof RoutesRecognized)
      .pairwise()
      .subscribe( (event: any[]) => {
        this.previousUrl = event[0].urlAfterRedirects;
        console.log(this.previousUrl);
      });

  }

  onSubmit(){
    if(!this.signinForm.valid || this.token == '' || this.user.civilite == 'empty'){
      return;
    }

    if(this.user.adresse2 == undefined){
      this.user.adresse2 = '';
    }

    if(this.user.telephone == undefined){
      this.user.telephone = '';
    }

    if(this.context == 'B2C'){
      this.user.typeUtilisateur = 305;
    } else {
      this.user.typeUtilisateur = +this.user.typeUtilisateur;
    }
    this.user.idPaysLPC = +this.user.idPaysLPC;
    this.user.acceptationInformationsKNE = false;
    if(this.etablissements.length > 0){
      let uais = Array();
      this.etablissements.forEach(function (e){
        uais.push(e.codeRNE);
      });
      this.user.uai = uais;
    } else {
      if(this.user.typeUtilisateur == 305){
        // 
      } else {
        return;
      }
    }

    console.log(this.user);

    this.userService.create(this.user)
      .subscribe(res => {
        this.response = res;
        this.hasError = false;
        this.msgAlert ="";
        this.isFinish=true;
      },
        err => {
            this.hasError = true;
             this.msgAlert=err[0].Message
        });

    // if(this.previousUrl == '/familles/panier/'){
    //   this.router.navigate([this.previousUrl]);
    // } else {
    //   this.router.navigate(['/familles']);
    // }

    /*if(this.context == 'B2B'){
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/familles']);
    }*/
  }

  checkUAI(){
    this.uai_error = false;
    if(this.etablissements.length == 0 || this.user.typeUtilisateur == 204){
      this.signinService.checkUAI(this.temp_uai)
        .subscribe(etablissement => {
          //only add it if unique
          if(this.etablissements.filter( e => e.codeRNE == etablissement.codeRNE ).length == 0){
            this.etablissements.push(etablissement);
            this.temp_uai='';
            if(this.user.typeUtilisateur != 204){
              this.disable_uai = true;
            }
          }
        },
        err => {
          if(err[0].Code == 'ETABLISSEMENT_NON_TROUVE'){
            this.uai_error = true;
          }
        });
    }
  }

  //click on trash icon
  removeFromEtablissements(uai:string){
    this.etablissements = this.etablissements.filter( e => e.codeRNE != uai );
    if(this.etablissements.length == 0){
      this.disable_uai = false;
    }
  }

  handleCorrectCaptcha(event){
    this.token = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/user/_sign-in/sign-in.component.ts